import React, { useEffect } from "react";

// router
import { Navigate, Route, useLocation } from "react-router-dom";

// redux
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { authCheck, logoutUser } from "../slices/apps/authSlice";

// hooks
import { useProfile } from "../Components/Hooks/UserHooks";

// toaster
import { toast } from "react-toastify";

// images
import Logo from "../assets/images/logo/metiner_avantaj_logo.png";

const AuthProtected = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();

  const { userProfile, loading, token } = useProfile();

  const { authCheckLoading } = useSelector((state) => {
    return {
      authCheckLoading: state.auth.authCheckLoading,
    };
  }, shallowEqual);

  useEffect(() => {
    if (!userProfile && loading && !token) {
      dispatch(logoutUser());
    }
  }, [token, userProfile, loading, dispatch]);

  useEffect(() => {
    const func = async () => {
      try {
        await dispatch(authCheck());
      } catch (error) {
        dispatch(logoutUser());
      }
    };

    if (token) {
      func();
    } else {
      dispatch(logoutUser());
    }
  }, []);

  useEffect(() => {
    toast.dismiss();
  }, [location.pathname]);

  if (!userProfile && loading && !token) {
    return <Navigate to={{ pathname: "/login", state: { from: location } }} />;
  }

  if (loading || !userProfile || authCheckLoading) {
    return (
      <div id="preloader">
        <div id="status">
          <img
            src={Logo}
            className="mb-2"
            alt="Metiner Avantaj+"
            style={{ objectFit: "contain", width: "10rem" }}
          />
          <div className="spinner-border text-primary avatar-xs" role="status">
            <span className="visually-hidden">Yükleniyor...</span>
          </div>
        </div>
      </div>
    );
  }

  const { path } = props.route;
  const accessibleRoutes = userProfile?.data?.accessibleRoutes || [];
  const hasAccess = accessibleRoutes.includes(path);
  const isSuperAdmin = userProfile?.data?.role === "Admin";

  if (isSuperAdmin || hasAccess) {
    return <>{props.children}</>;
  } else if (path === "*") {
    return <Navigate to="/404" />;
  } else {
    return <Navigate to="/401" />;
  }
};

export { AuthProtected };
